import { createRootRouteWithContext, Outlet } from '@tanstack/react-router';
import { TanStackRouterDevtools } from '@tanstack/router-devtools';

import { LBScrollToTop } from '@/shared/modules';
import type { Profile } from '@/shared/store/profileStore';

export interface RouterContext {
  auth: {
    isAuthenticated: boolean;
    profile: Profile | null;
    currentSessionId: number | null;
  };
}

export const Route = createRootRouteWithContext<RouterContext>()({
  component: () => (
    <div>
      <LBScrollToTop />
      <Outlet />
      {import.meta.env.MODE === 'development' && <TanStackRouterDevtools />}
    </div>
  )
});
